module.exports = __webpack_public_path__ + "img/Middle_Exhibition_Logo.45f11ef5.png";